import React, { useState, useEffect, Fragment } from 'react';
import cn from 'classnames';
import ReactJson from 'react-json-view';
import PropTypes, { object } from 'prop-types';

import { Table, Text, Icon } from 'components/common/Elements/Elements';
import Policy from './Policy/Policy';
import AppIcon from './AppIcon/AppIcon';

import { policiesTableConf } from '../helpers/configurates';

import classes from './PlatformPoliciesTable.module.scss';

const PlatformPoliciesTable = ({ tableData, jsonPolicy, handlePolicies }) => {
  const [idOpenData, setIdOpenData] = useState('');

  useEffect(() => {
    jsonPolicy._id !== idOpenData
      ? setIdOpenData(jsonPolicy._id)
      : setIdOpenData('');
    // eslint-disable-next-line
  }, [jsonPolicy]);

  const handleOpenData = id => {
    handlePolicies(id);
  };

  return (
    <Table fixed className={classes.table}>
      <Table.Header>
        <Table.Row withBorder={false}>
          {policiesTableConf.map(({ field, title }) => (
            <Table.HeaderCell
              key={field}
              className={cn(classes.headerCell, classes.sortable)}
              title={title}
            ></Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {tableData &&
          tableData.map(policies => (
            <Fragment key={policies._id}>
              <Table.Row
                onClick={() => handleOpenData(policies._id)}
                className={classes.row}
              >
                <Table.Cell className={classes.tableCell}>
                  <Policy data={policies} />
                </Table.Cell>
                <Table.Cell
                  className={classes.tableCell}
                  classNameContent={classes.content}
                >
                  {policies.applications.length > 0 &&
                    policies.applications.map((application, index) => (
                      <div
                        key={application._id}
                        className={classes.application_cell}
                      >
                        <AppIcon icon={application.icon} />
                        <Text className={classes.application_name}>
                          {application.name}
                        </Text>
                        {index !== policies.applications.length - 1 && (
                          <Text className={classes.application_name}>
                            ,&nbsp;
                          </Text>
                        )}
                      </div>
                    ))}
                </Table.Cell>
                <Table.Cell className={classes.tableCell}>
                  <Icon
                    size={'32px'}
                    icon="arrow"
                    color="#3a5ba2"
                    className={
                      idOpenData === policies._id ? classes.iconUp : ''
                    }
                  />
                </Table.Cell>
              </Table.Row>
              {idOpenData === policies._id && (
                <Table.Row key={policies._id}>
                  <Table.Cell colSpan={7}>
                    {typeof log !== 'string' ? (
                      <ReactJson
                        src={jsonPolicy}
                        iconStyle="triangle"
                        enableClipboard={false}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        indentWidth={4}
                        collapsed={false}
                      />
                    ) : (
                      <p className={classes.textData}>{jsonPolicy}</p>
                    )}
                  </Table.Cell>
                </Table.Row>
              )}
            </Fragment>
          ))}
      </Table.Body>
    </Table>
  );
};

PlatformPoliciesTable.propTypes = {
  tableData: PropTypes.arrayOf(object),
  jsonPolicy: PropTypes.any,
  handlePolicies: PropTypes.func.isRequired
};

export default PlatformPoliciesTable;
